import { render, staticRenderFns } from "./SalesLeadsByPageChart.vue?vue&type=template&id=b7118836&scoped=true&"
import script from "./SalesLeadsByPageChart.vue?vue&type=script&lang=js&"
export * from "./SalesLeadsByPageChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7118836",
  null
  
)

export default component.exports